import { render, staticRenderFns } from "./IndexHome.vue?vue&type=template&id=da8f0530&scoped=true"
import script from "./IndexHome.vue?vue&type=script&lang=js"
export * from "./IndexHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8f0530",
  null
  
)

export default component.exports